import {
  Avatar,
  Box,
  Button,
  Modal,
  Heading,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay
} from '@homebotapp/hb-react-component-catalog'
import { defineMessages, useIntl } from 'react-intl'
import { MikasaCustomerDisplay } from '../../api/mikasa/type/mikasa_customer_display'

export const MSG = defineMessages({
  selectYourProfile: {
    id: 'SelectCustomerProfile.selectYourProfile',
    defaultMessage: 'Select your profile'
  }
})

interface Props {
  profiles: MikasaCustomerDisplay[]
  isOpen: boolean
  onClose: () => void
  onSelect: (profile: MikasaCustomerDisplay) => Promise<void>
}

export const SelectCustomerProfile = ({ profiles, isOpen, onClose, onSelect }: Props) => {
  const intl = useIntl()

  return (
    <Box position={'fixed'} bottom={0} right={10} zIndex={1000}>
      <Modal isOpen={isOpen} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <Heading size='md' textAlign='left'>
              {intl.formatMessage(MSG.selectYourProfile)}
            </Heading>
          </ModalHeader>
          <ModalBody>
            {profiles.map(profile => (
              <Button
                mb={4}
                width='100%'
                key={profile.clientId}
                onClick={() => onSelect(profile)}
                leftIcon={<Avatar size='xs' src={profile.photo} />}
              >
                {profile.firstName} {profile.lastName}
              </Button>
            ))}
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  )
}
